
import RequestPromises from "@/mixins/requestPromises";
import { Component, Provide } from "vue-property-decorator";
import {
  IChartProvider,
  IChartProviderMethods
} from "@/models/providers/chart";

@Component
export default class ChartProvider extends RequestPromises {
  // Data

  public hoverIndex = null;
  public hoverDatasetIndex = null;

  // Methods

  public setHover({ hoverIndex, hoverDatasetIndex }) {
    this.hoverIndex = hoverIndex;
    this.hoverDatasetIndex = hoverDatasetIndex;
  }

  // Provider

  @Provide()
  public chartProvider(): IChartProvider {
    return {
      hoverIndex: this.hoverIndex,
      hoverDatasetIndex: this.hoverDatasetIndex
    };
  }

  @Provide()
  public get chartProviderMethods(): IChartProviderMethods {
    return {
      setHover: this.setHover
    };
  }

  // Life-cycle methods

  public render() {
    // Renderless, no HTML is rendered for this component
    return (
      this.$scopedSlots?.default &&
      this.$scopedSlots.default({
        $chartData: this.chartProvider(),
        $chartMethods: this.chartProviderMethods
      })
    );
  }
}
